const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/eCheckin/sections/KontaktPerson.tsx';
import * as React from 'react';
import { forwardRef, useEffect, useState } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import { ECheckinSectionProps, FieldPathModifier } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { actionRemoveFromCIS4mDataObject } from '@cistec/common_web/modules/CIS4m/actions';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { useDispatch } from 'react-redux';
import KontaktPersonBlock from './components/KontaktPersonBlock';
import { createFieldPath, fieldValueIsNot } from 'App/components/eCheckin/utils';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';

const secondContactPersonFieldPathModifier: FieldPathModifier = fieldPath => {
    return `second${fieldPath}`;
};

export const KontaktPerson = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);
    const { formatMessage } = useIntl();

    const PATH_PRIORTIY_FIRST = createFieldPath(path, `priority`);
    const PATH_PRIORTIY_SECOND = createFieldPath(path, `secondpriority`);

    const eCheckinSectionRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();

    const dispatch = useDispatch<any>();

    const formData = useCIS4mData();

    const priorityFirst = !fieldValueIsNot(formData, PATH_PRIORTIY_FIRST, ['1']);
    const prioritySecond = !fieldValueIsNot(formData, PATH_PRIORTIY_SECOND, ['1']);

    const [priorities, setPriorities] = useState([priorityFirst, prioritySecond]);

    useEffect(() => {
        // Bit of a nasty way to make sure only one contact person is selected for priority
        if (priorityFirst && prioritySecond) {
            if (priorities[0]) {
                dispatch(actionRemoveFromCIS4mDataObject(formId, PATH_PRIORTIY_FIRST));
            } else if (priorities[1]) {
                dispatch(actionRemoveFromCIS4mDataObject(formId, PATH_PRIORTIY_SECOND));
            }
        }
        setPriorities([priorityFirst, prioritySecond]);
    }, [priorityFirst, prioritySecond]);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <h4>{formatMessage(textMap.prioritycontact)}</h4>
            <p>{formatMessage(textMap.contactdescription)}</p>
            <KontaktPersonBlock basePath={path} required={true} />
            <h4>{formatMessage(textMap.secndBeziehung)}</h4>
            <KontaktPersonBlock basePath={path} fieldPathModifier={secondContactPersonFieldPathModifier} />
        </ECheckinSection>
    );
});

KontaktPerson.displayName = 'KontaktPerson';

export default KontaktPerson;
